exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".white-text[data-v-e7c3d17a]{color:#fff!important}.fellow-box[data-v-e7c3d17a]{border:1px solid #d8d8d8;background:#ededed;padding:10px;margin-bottom:10px}.result_box_success[data-v-e7c3d17a]{font-size:200%;text-align:center;color:#fff}.result_box_warning[data-v-e7c3d17a]{font-size:120%;text-align:center;color:#000}#result_euro[data-v-e7c3d17a]{font-size:125%;font-weight:700;display:block}", ""]);

// exports
